import React from 'react'
import useStyles from './styles'

interface BaseStatusIndicatorProps {
  baseStatus: string
}

const BaseStatusIndicator: React.FC<BaseStatusIndicatorProps> = ({
  baseStatus
}) => {
  const classes = useStyles()

  return <div className={classes.title}> {baseStatus} </div>
}

export default BaseStatusIndicator
